define('bindingHandlers/durationRangePicker',[
    'lib/knockout',
    'lib/lodash4',
    'enums/bindingHandlers/rangePickerModes',
    'bindingHandlers/include'
], function (ko, _, RANGE_PICKER_MODES) {
    "use strict";

    // Increment everytime this handler is used so that the mode group gets unique names
    var durationRangePicker = 0;

    /**
     * Duration Picker
     *
     * @description: creates a simple two input box div that allows users to enter
     *      minutes and pass that data on to another view
     *
     * REQUIRES:
     *
     * start (observable) -  this comes from the durationRangePicker binding and should be an
     *      observable only. The logic below will take the input and pass it back into
     *      the observable to be consumed by another view
     * end (observable)   -  this also comes from the durationRangePicker binding and follows
     *      the same path as start
     */

    ko.bindingHandlers.durationRangePicker = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var self = this;

            var MAX_SUPPORTED_DURATION = (100 * 3600000) + (59 * 60000) + (59 * 1000);

            // create variable to hold the duration picker template
            var duration_range_template = 'templates/widgets/durationPicker/durationRange_hms';
            var templateData = [];

            var bindingData = valueAccessor();

            // populate the template data with the start and end observable
            templateData.start = bindingData.start;
            templateData.end = bindingData.end;
            if (bindingData.mode) {
                templateData.mode = bindingData.mode;
            } else {
                templateData.mode = ko.observable();
            }      
              
            templateData.radioGroupName = "modeGroup" + durationRangePicker++;
            templateData.RANGE_PICKER_MODES = RANGE_PICKER_MODES;

            if (bindingData.template && typeof(bindingData.template) === 'string') {
                duration_range_template = bindingData.template;
            }

            /*
             * Verify that the start and end numbers are actually numbers
             */
            var start = templateData.start();
            if (!_.isInteger(start)) {
                templateData.start(0);
            }

            var end = templateData.end();
            if (!_.isInteger(end)) {
                templateData.end(0);
            }

            // infer the mode from the initial start and end values
            if( !(bindingData.mode && bindingData.mode() != null))
            {
                if ( templateData.start() === 0 && templateData.end() > 0) {
                    templateData.mode(RANGE_PICKER_MODES.UNDER);
                }
                else if (templateData.start() > 0 && templateData.end() === MAX_SUPPORTED_DURATION) {
                    templateData.mode(RANGE_PICKER_MODES.OVER);
                }
            }
            if(_.isUndefined(templateData.mode())){
                templateData.mode(RANGE_PICKER_MODES.BETWEEN);
            }  
            // pick reasonable settings when the mode is changed
            templateData.mode.subscribe(function(newValue) {
                if (newValue == RANGE_PICKER_MODES.BETWEEN) {
                    templateData.start(0);
                    templateData.end(0);
                }

                if (newValue == RANGE_PICKER_MODES.UNDER) {
                    templateData.start(0);
                    templateData.end(0);
                }

                if (newValue == RANGE_PICKER_MODES.OVER) {
                    templateData.start(0);
                    templateData.end(MAX_SUPPORTED_DURATION);
                }
            });


            var includeValueAccessor = ko.observable({
                name: duration_range_template,
                data: templateData
            });

            ko.bindingHandlers.include.init.call (self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
            ko.bindingHandlers.include.update.call(self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
        }

    };
});

